import { Button } from '@ipfabric/ui-components/Button/Button';
import { SidePanel } from '@ipfabric/ui-components/SidePanel/SidePanel';
import { useCustomForm } from '@ipfabric/ui-components/utils/hookForm/useCustomForm';
import { type FC, useState } from 'react';
import { FormProvider, type SubmitHandler } from 'react-hook-form';
import { useApi } from 'utils/request/useApi';
import { ExportSidePanelContent } from './ExportSidePanelContent';
import type { ExportForm } from './importExportConfiguration.types';

interface Props {
  onClose: () => void;
}

export const ExportSidePanel: FC<Props> = (props) => {
  const formMethods = useCustomForm<ExportForm>({
    defaultValues: {
      exportEverythingToFile: true,
      passphrase: '',
      passphraseRepeat: '',
    },
  });

  const api = useApi();

  const [configurationOptions, setConfigurationOptions] = useState(
    new Set<string>(),
  );

  const onSubmit: SubmitHandler<ExportForm> = async (data) => {
    await api.request({
      url: '/appliance-configuration/export',
      method: 'POST',
      data: {
        configurationOptions: [...configurationOptions],
        passphrase: data.passphrase,
      },
    });

    props.onClose();
  };
  return (
    <FormProvider {...formMethods}>
      <SidePanel
        closeOnBackdropClick={false}
        onClose={props.onClose}
        title='Export configuration'
        footer={
          <div className='flex gap-xs'>
            <Button
              disabled={
                !formMethods.formState.isDirty ||
                configurationOptions.size === 0
              }
              loading={formMethods.formState.isSubmitting}
              variant='primary'
              onClick={formMethods.handleSubmit(onSubmit)}
              type='submit'
              className='grow'
              icon='fa-file-export'
            >
              Export configuration
            </Button>
            <Button variant='outline' onClick={props.onClose} className='grow'>
              Close
            </Button>
          </div>
        }
      >
        <ExportSidePanelContent
          values={configurationOptions}
          onChange={setConfigurationOptions}
        />
      </SidePanel>
    </FormProvider>
  );
};
